<template>
	<div class="history-container">
		<div class="history-custom">
			<chat-custom menuType='2' @custom-call="customCall($event)" @chat-custom-call="customAllCall($event)"></chat-custom>
		</div>
		<div class="history-contact">
			<history-contact  @contact-click="contactCall($event)" :currentCustom="currentCustom"></history-contact>
		</div>
		<div class="history-detail">
			<history-detail :currentContact="currentContact" :customList="customList"></history-detail>
		</div>
	</div>
</template>

<script>
	import ChatCustom from "../../components/ChatCustom.vue"
	import HistoryContact from "./HistoryContact.vue"
	import HistoryDetail from "./HistoryDetail.vue"
	
	export default{
		name:'HistoryHome',
		components:{
			ChatCustom,
			HistoryContact,
			HistoryDetail
		},
		data(){
			return{
				currentContact:{
					id:0
				},
				currentCustom:{
					id: 0,
					open_id: ''
				},
				customList:[]
			}
		},
		methods:{
			// 客服点击回调
			customCall(data){
				this.currentCustom = data
			},
			
			// 客服列表回调
			customAllCall(data){
				this.customList = data
			},
			
			// 列表点击回调
			contactCall(item){
				this.currentContact = item
			}
		}
	}
</script>

<style scoped>
	.history-container{
		position: relative;
		width: 100%;
		height: 100%;
	}
	.history-container .history-custom{
		width: 80px;
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		overflow: hidden;
		background-color: #27354a;
	}
	.history-container .history-contact{
		width: 400px;
		position: absolute;
		top: 0;
		left: 80px;
		bottom: 0;
		overflow: hidden;
		background-color: #efefef;
	}
	.history-container .history-detail{
		position: absolute;
		top: 0;
		left: 480px;
		bottom: 0;
		right: 0;
		overflow: hidden;
	}
</style>
